import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { REJECT_ENVELOPE_MODAL, BUTTONS } from '@/utils/constants/appConstants/commonConstants';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';

interface RejectEnvelopeModalProps {
    show: boolean;
    onHide: () => void;
    onReject: () => void;
    reason: string;
    setReason: (reason: string) => void;
}

const RejectEnvelopeModal: React.FC<RejectEnvelopeModalProps> = ({ show, onHide, onReject, reason, setReason }) => {
    const handleReject = () => { onReject(); onHide(); };

    return (
        <Dialog open={show} onOpenChange={(open) => { if (!open) onHide(); }}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{REJECT_ENVELOPE_MODAL.REASON_FOR_REJECTION_TEXT}</DialogTitle>
                </DialogHeader>
                <div className="px-1 py-2">
                    <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder={REJECT_ENVELOPE_MODAL.PLACEHOLDER_TEXT} className="min-h-[80px]" />
                </div>
                <DialogFooter>
                    <Button variant="destructive" onClick={handleReject} disabled={!reason.trim()}>{BUTTONS.REJECTED}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default RejectEnvelopeModal;
